import { render, staticRenderFns } from "./RevisionsManager.vue?vue&type=template&id=eb5e6f58&scoped=true"
import script from "./RevisionsManager.vue?vue&type=script&lang=js"
export * from "./RevisionsManager.vue?vue&type=script&lang=js"
import style0 from "./RevisionsManager.vue?vue&type=style&index=0&id=eb5e6f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5e6f58",
  null
  
)

export default component.exports